function orderby() {
	$('a[data-orderby]').on('click', function(e){
		e.preventDefault();
		let value = $(this).data('orderby'),
			url = new URL(window.location.href);

		url.searchParams.set('orderby', value);

		$('.dropdown-button__orderby').text($(this).text());

		if( window.location.href !== url.href ) {
			window.location.href = url.href;
		}
	});
}


orderby();
